export const SECURITY_AUTH = 'SECURITY_AUTH'
